module.exports = __webpack_public_path__ + "static/hosted-thomson-colored-772885d1a1f33c723c6d2a57a91e3b51.png";